import React from "react";
import { Spinner } from "../shared/Spinner";

function withLoading(Component) {
  return function WihLoadingComponent({ isLoading, ...props }) {
    if (!isLoading) return <Component {...props} />;
    return (
      <div className="sweet-loading">
        <Spinner size="lg" center />
      </div>
    );
  };
}
export default withLoading;
